// extracted by mini-css-extract-plugin
export default {"description":"TravelHealthInsuranceModal_description__5E7p2"};